import React from 'react';

import { Link, useNavigate } from 'react-router-dom';

import Button from 'components/common/Button/Button';
import { LogoIcon } from 'components/common/Icons/Icons';

import styles from './NotFoundPage.module.scss';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    navigate('/');
  };

  return (
    <div className={styles.container}>
      <Link to="/" className={styles.logo}>
        <LogoIcon />
      </Link>
      <div className={styles.contentContainer}>
        <h1 className={styles.title}>Page not found!</h1>
        <p className={styles.text}>Sorry, but the page you were looking for could not be found.</p>
        <Button className={styles.button} onClick={handleOnClick}>
          Return to Home Page
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
